export function storageMiddlewareProvider (actionSet = []) {
  const timestampAction = (action) => ({
    action,
    time: Date.now()
  })

  return () => (next) => (action) => {
    if (actionSet.includes(action.type)) {
      const stampedAction = timestampAction(action)
      window.localStorage.setItem(
        'MIDDLEWARE_ACTION',
        JSON.stringify(stampedAction))
    }
    // console.log('evento', action)
    next(action)
  }
}
